import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Form, Button, Modal, ModalBody } from 'react-bootstrap';
import Forgot from './forgot';
import axios from 'axios';
import Cookies from 'universal-cookie';
import ls from "local-storage";
import { Trans } from "react-i18next";
import { options } from "../../config/options";   
import "../../config/i18n";
import { withTranslation } from "react-i18next";

class Signin extends Component {

    constructor(props) {
        super(props);
        this.onChangeSigninemail = this.onChangeSigninemail.bind(this);
        this.onChangeSigninpassword = this.onChangeSigninpassword.bind(this);
        this.onSubmitsignin = this.onSubmitsignin.bind(this);
        this.enable_accountActivated = this.enable_accountActivated.bind(this);
        this.cancel_accountActivated = this.cancel_accountActivated.bind(this);
        this.redirectifsignin = this.redirectifsignin.bind(this)
        this.state = {
            forgotmodal: false,
            langKey: ls.get('LangValue'),
            api_url: localStorage.getItem('api_url'),
            signin_email: '',
            signin_password: '',
            errorMsg: '',
            errors: {},
            accountActivated: false,
            accountActivatedModel: false,
            disaccountActivatedOTp: false,
            otp: '',
            numInputs: 4,
            separator: '-',
            isDisabled: false,
            hasErrored: false,
            isInputNum: true,
        };
    }



    componentDidMount() {
        this.redirectifsignin();
        if (this.props.i18n.language === 'ar' || this.props.i18n.language === 'he') {
            document.body.dir = 'rtl';
            document.body.classList.add('rtl');
            document.body.classList.remove('ltr')
        } else {
            document.body.dir = 'ltr';
            document.body.classList.remove('rtl');
            document.body.classList.add('ltr');
        }
    }

    redirectifsignin(){
        let cookies = new Cookies();
        let onboarded = cookies.get("onboarded")

        console.log(onboarded);

        if(onboarded==true){
            this.props.history.push('/find')
        }
    }

    /** Signin */
    enable_accountActivated() {
        this.setState({ accountActivated: false });
        this.accountActivatedOtp();
    }

    accountActivatedOtp() {
        var accountActivated = new FormData();
        accountActivated.append('email', this.state.email);
        accountActivated.append('language', this.state.langKey);
        axios({
            method: 'post',
            url: this.state.api_url + 'activateaccountweb',
            data: accountActivated,
            config: { headers: { 'Content-Type': 'multipart/form-data' } }
        }).then(res => {
            if (res.data.status === 'true') {
                this.props.history.push('/verify')

            }
        });
    }

    cancel_accountActivated() {
        this.setState({ accountActivated: false });
    }

    onChangeSigninpassword(e) {
        this.setState({
            signin_password: e.target.value
        });
    }

    onChangeSigninemail(e) {
        this.setState({
            signin_email: e.target.value
        });
    }

    onSubmitsignin(e) {
        e.preventDefault();
        let errors = {};
        const cookies = new Cookies();
        var signin = new FormData();
        signin.set('email', this.state.signin_email);
        signin.set('password', this.state.signin_password);
        signin.set('language', this.state.langKey);
        localStorage.setItem('signin_email', this.state.signin_email);

        axios({
            method: 'post',
            url: this.state.api_url + 'webemaillogin',
            data: signin,
            config: { headers: { 'Content-Type': 'multipart/form-data' } }
        }).then(res => {
            const message = res.data.message;
            let formIsValid = true;
            if (res.data.status !== "true") {
                if (res.data.message === "Your account has been disabled") {
                    this.setState({
                        accountActivated: true
                    });
                    const email = res.data.email || '';
                    this.setState({ email });
                } else {
                    formIsValid = false;
                    errors["login"] = message;
                    this.setState({
                        errors: errors,
                        errorMsg: 'errorMsg'
                    });
                    setTimeout(() => {
                        this.setState({
                            errors: ''
                        });
                    }, 2000);
                }
            } else {
                var loginstatus = new FormData();
                loginstatus.set('user_id', res.data.peoples.user_id);
                loginstatus.set('status', '1');
                loginstatus.set('language', this.state.langKey);
                axios({
                    method: 'post',
                    url: this.state.api_url + 'webonlinestatus',
                    data: loginstatus,
                    config: { headers: { 'Content-Type': 'multipart/form-data' } }
                })
                localStorage.setItem('session_token', JSON.stringify(res.data.peoples.token));
                localStorage.setItem('session_userid', JSON.stringify(res.data.peoples.user_id));
                localStorage.setItem('seleted_religion', res.data.peoples.relogion);
                localStorage.setItem('selected_language', res.data.peoples.language);
                sessionStorage.setItem('loggedin', 'true');
                let d = new Date();
                d.setTime(d.getTime() + (12 * 60 * 60 * 1000));
                cookies.set('onboarded', 'true', { path: "/", expires: d });
                this.props.history.push('/find')
            }
            this.setState({
                errors: errors
            });
            return formIsValid;
        })
    }

    handleSubmitaccountActivated = e => {
        e.preventDefault(); 
        let errors = {};
        var emailVerify = new FormData();
        emailVerify.set('otp', this.state.otp);
        emailVerify.set('email', this.state.email);
        emailVerify.set('language', this.state.langKey);   
        
        axios({
            method: 'post',
            url: this.state.api_url+'verifyaccountweb',
            data: emailVerify,
            config: { headers: {'Content-Type': 'multipart/form-data' }}
        }).then(res => { 
            if(res.data.status !== "true") { 
                errors["otpverify"] = res.data.message;  
                this.setState({
                    errors: errors,
                    errorMsg:'errorMsg'
                });
                setTimeout(() => {
                    this.setState({
                        errorMsg: 'errorMsghide'
                    });
                }, 2000);  
            } else { 
                this.setState({ disaccountActivatedOTp: false });
                this.showModal('accountActivatedModel');
            }
        })
    }

    handleOtpChange = otp => {
        this.setState({ otp });
    };

    showModal(modal) {
        this.setState({
            [modal]: true
        });
    }
    /** Signin */

    /** Forgot */
    handleForgotModal = () => {
        this.setState({ forgotmodal: true });
    }

    handleForgotCloseModal = () => {
        this.setState({ forgotmodal: false });
    }
    /** Forgot */

    render() {
        const { t } = this.props;
        return (
            <div className="">
                <Form className="welcome_form" onSubmit={this.onSubmitsignin}>
                    <Form.Group controlId="formPlaintextEmail" className="welcome_form_div">
                        <Form.Label><Trans i18nKey="email">E-mail</Trans></Form.Label>
                        <div >
                            <Form.Control type="email" placeholder={t("enteryouremail")} onChange={this.onChangeSigninemail} value={this.state.signin_email} required />
                        </div>
                    </Form.Group>

                    <Form.Group controlId="formPlaintextPassword" className="mb-0 welcome_form_div">
                        <Form.Label><Trans i18nKey="password">Password</Trans></Form.Label>
                        <div>
                            <Form.Control type="password" placeholder={t("enteryourpassword")} onChange={this.onChangeSigninpassword} value={this.state.signin_password} required />
                        </div>
                    </Form.Group>

                    <p className='forgot_txt' onClick={this.handleForgotModal}>
                        <Trans i18nKey="forgotpassword?">Forgot password?</Trans>
                    </p>

                    <div className={this.state.errorMsg}>{this.state.errors.login}</div>

                    <div className='signin_mt'>
                        <button className="button_primary"><Trans i18nKey="SIGNIN">SIGN IN</Trans></button>
                    </div>
                </Form>

                <Forgot
                    showModal={this.state.forgotmodal}
                    handleClose={this.handleForgotCloseModal}
                />

                <Modal className="modal_div boostplan_modal accountmodal" show={this.state.accountActivated} onHide={this.props.handleClose} centered>
                    <Modal.Body className="accountmodalbody">
                        <div className='accountmodalbodydiv'>
                            <h4>Alert Message</h4>
                            <p>Your account has been deactivated, please activate</p>
                        </div>
                    </Modal.Body>
                    <Modal.Footer className="forgot_button_plr accountmodal_btn">
                        <Button className='accountmodal_cancelbtn' onClick={this.cancel_accountActivated}>
                            Cancel
                        </Button>
                        <Button className='button_primary accountmodal_primarybtn' onClick={this.enable_accountActivated}>
                            Activate
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

export default withTranslation("translations")(withRouter(Signin));
